import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormControl, InputGroup, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import TBLTaxas from "../../components/TBLTaxas";
import { ListarEstabelecimentosSemPaginacao } from "../../providers/EstabelecimentoProvider";
import {
  cadastrarInfoFinanceiras,
  deletarInfoFinanceiras,
  editarInfoFinanceiras,
  getInfoFinanceiras,
} from "../../providers/InfoFinanceiraProvider";

function FinanceiroTaxas() {
  const [search, setSearch] = useState();
  const [data, setData] = useState([]);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [estabelecimentoSelecionado, setEstabelecimentoSelecionado] = useState();
  const [taxaSelecionada, setTaxaSelecionada] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isEdition, setEdition] = useState(false);
  const [form, setForm] = useState({
    taxa_manutencao: 0,
    taxa_operacao: 0,
    estabelecimento: "",
  });
  const [formError, setFormError] = useState("");

  const getTaxas = async () => {
    const taxas = await getInfoFinanceiras();
    setData(taxas);
    setDataFiltered(taxas);
  };

  useEffect(() => {
    (async () => {
      await getTaxas();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const docs = await ListarEstabelecimentosSemPaginacao();
      const mappedOptions = docs.map((d) => ({
        label: d.nome_fantasia,
        value: d._id,
      }));
      setEstabelecimentos(mappedOptions);
    })();
  }, []);

  useEffect(() => {
    if (search) {
      setDataFiltered((prev) =>
        prev.filter((t) =>
          t.estabelecimento?.nome_fantasia.toLowerCase().includes(search.toLowerCase()),
        ),
      );
    } else {
      setDataFiltered(data);
    }
  }, [search]);

  const limparForm = () => {
    setForm({});
    setEstabelecimentoSelecionado(null);
    setTaxaSelecionada(null);
    setShowCreateModal(false);
    setShowDeleteModal(false);
    setEdition(false);
  };

  const receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      setForm({ ...dados, estabelecimento: dados.estabelecimento?._id });
      setTaxaSelecionada(dados);
      setEstabelecimentoSelecionado({
        label: dados.estabelecimento?.nome_fantasia,
        value: dados.estabelecimento?._id,
      });
      setShowCreateModal(true);
      setEdition(true);
    } else if (tipo === "deletar") {
      setTaxaSelecionada(dados);
      setShowDeleteModal(true);
    } else {
      return;
    }
  };

  const validarForm = () => {
    let isValid = true;
    let error = "";
    if (!form.taxa_operacao || !form.taxa_manutencao) {
      error = "Campo obrigatório";
      isValid = false;
    }
    if (!estabelecimentoSelecionado?.value) {
      error = "Estabelecimento é obrigatório";
      isValid = false;
    }
    setFormError(error);
    return isValid;
  };

  const cadastrarTaxa = async () => {
    if (validarForm()) {
      try {
        const response = await cadastrarInfoFinanceiras({
          ...form,
          estabelecimento: estabelecimentoSelecionado.value,
        });
        if (response) {
          await getTaxas();
          limparForm();
          toast.success("Taxa cadastrada com sucesso", "success");
        }
      } catch (error) {
        toast.error(
          "Erro: Dados inválidos ou taxa já cadastrada nesse estabelecimento",
          "error",
        );
      }
    }
  };

  const editarTaxa = async () => {
    if (validarForm()) {
      try {
        const response = await editarInfoFinanceiras(taxaSelecionada._id, form);
        if (response) {
          await getTaxas();
          limparForm();
          toast.info("Taxa editada com sucesso", "success");
        }
      } catch (error) {
        console.log(error);
        toast.error("Erro ao editar Taxa", "error");
      }
    }
  };

  const deletarTaxa = async () => {
    try {
      const response = await deletarInfoFinanceiras(taxaSelecionada._id);
      if (response) {
        await getTaxas();
        limparForm();
        toast.info("Taxa deletada com sucesso", "success");
      }
    } catch (error) {
      toast.error("Erro ao deletar Taxa", "error");
    }
  };

  return (
    <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
      <br></br>
      <Row>
        <Col md={9}>
          <h3>Taxas da Operação</h3>
        </Col>
        <Col>
          <Button onClick={() => setShowCreateModal(true)}>Cadastrar Taxa</Button>
        </Col>
      </Row>
      <br></br>
      <Row>
        <Col md={12}>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              placeholder="Pesquisar por nome"
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
      <TBLTaxas data={dataFiltered} numRows={13} dataCallback={receberDadosTabela} />
      <br></br>
      <Modal size="lg" show={showCreateModal} onHide={() => limparForm()}>
        <Modal.Header closeButton className="modalHeader">
          <Modal.Title>
            {isEdition ? "Editar Taxa de Operação" : "Cadastrar Taxa de Operação"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formError ? (
            <div>
              <p style={{ color: "red" }}>{formError}</p>
            </div>
          ) : null}
          <Form>
            <Form.Group>
              <Form.Label>Escolha o Estabelecimento *</Form.Label>
              <Select
                isDisabled={!estabelecimentos.length}
                value={estabelecimentoSelecionado}
                isClearable
                isSearchable
                onChange={(opt) => {
                  setEstabelecimentoSelecionado(opt);
                }}
                options={estabelecimentos}
                placeholder="Estabelecimento"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Taxa de Operação *</Form.Label>
              <Form.Control
                value={form.taxa_operacao}
                type="number"
                min={0}
                max={1}
                placeholder="0,00"
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (value < 0 || value > 1) return;
                  setForm((prev) => ({ ...prev, taxa_operacao: value }));
                }}
              />
              <Form.Text>Ex: 0,2 equivale a 20%</Form.Text>
            </Form.Group>
            <Form.Group>
              <Form.Label>Taxa de Manutenção *</Form.Label>
              <Form.Control
                value={form.taxa_manutencao}
                type="number"
                min={0}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  setForm((prev) => ({ ...prev, taxa_manutencao: value }));
                }}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              limparForm();
            }}
          >
            Fechar
          </Button>
          {isEdition ? (
            <Button
              variant="primary"
              onClick={() => {
                editarTaxa();
              }}
            >
              {"Editar"}
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                cadastrarTaxa();
              }}
            >
              {"Cadastrar"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal size="sm" show={showDeleteModal} onHide={() => limparForm()}>
        <Modal.Header closeButton>
          <Modal.Title>Alerta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Deseja realmente excluir a taxa de operação?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              limparForm();
            }}
          >
            Não
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              deletarTaxa();
            }}
          >
            Sim
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FinanceiroTaxas;
